// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7j-0";
export var optionCard = "_7j-1";